(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('Metier', Metier);

    Metier.$inject = ['$resource'];

    function Metier ($resource) {
        var resourceUrl =  'api/metiers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
